import React, { useState, useEffect } from "react";

import ProfileBox from "../../Components/ProfileBox/ProfileBox";
import { Link } from "react-router-dom";
import { FeedDate, Icon } from "semantic-ui-react";
import "./TeacherProfile.css";
import TeacherComplimentsBadge from "./TeacherComplimentsBadge";
import "../Home/HomeCarouselScript.js";
import CanDeliverForm from "../Home/CanDeliverForm.redux";
import { createUserObject } from "./profile.utils";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import { getClassCategories, getBadges } from "../../Helper";
import moment from "moment";
import { API } from "../../API";
import { notify } from "react-notify-toast";
import {displayPoliceCheckWwCC} from "../Container/HomeContainer2";
import RoomOrProgramPopup from "../Home/RoomOrProgramPopup.js";

const _ = require('lodash')

const TeacherProfile = (props) => {
  const [isClassPopup, toggleClassPopup] = useState(false);
  const [badges, setBadges] = useState([])
  const [hasMore, setHasMore] = useState(true)
  const [selectedList, setSelectedList] = useState([])
  const [selectedByQualification, setSelectedByQualification] = useState({})
  const [roomsOrProgramsList, setRoomsOrProgramsList] = useState([])
  const [isRoomsOrProgramsPopup, setIsRoomsOrProgramsPopup] = useState(false);

  const {
    user,
    setUser,
    isShowFooter,
    seeResume,
    isShared,
    addCanDeliver,
    isViewAsAdmin,
    addCanDeliverAdmin,
    qualifications
  } = props;

  const toggleClass = () => {
    toggleClassPopup(true);
  };

  const toggleRoomsOrPrograms = () => {
    setIsRoomsOrProgramsPopup(true);
  };

  let updateResumeButton = null;
  let addMoreCanDeliver;
  let displaySeeResume;
  let addMoreRoomsOrPrograms
  //constructe the userObject to present in the can delivers.
  const userObject = createUserObject(user);
  const [feedbacks, setFeedbacks] = useState([]);
  const all_categories = getClassCategories();
  const cd_categories = Object.keys(userObject).filter(
    (category) => userObject[category].length
  );
  const isCanDeliver = !!Object.keys(selectedList)?.length

  /*Footer will be shown at Home page. Invisible at PreviewProfile page*/
  const buildFooterLink = (path, text) => {
    return (
      <div className="col">
        <Link to={path}>
          <Icon
            name="pencil"
            circular
            inverted
            color="teal"
            className="qualification-container-update-icon"
          ></Icon>
          {"  "}
          {text}
        </Link>
      </div>
    );
  };

  if (isShowFooter) {
    if (user.is_elt === true && user.is_vet === true) {
      updateResumeButton = (
        <div className="container">
          <div className="row">
            {buildFooterLink("/Resume", "Update ELT Resume")}
            {buildFooterLink("/VocationalResume", "Update VET Resume")}
          </div>
        </div>
      );
    } else if (user.is_elt === true) {
      updateResumeButton = (
        <div className="row">{buildFooterLink("/Resume", "Update Resume")}</div>
      );
    } else if (user?.is_childhood_teacher) {
      updateResumeButton = (
        <div className="row">{buildFooterLink("/ececResume", "Update Resume")}</div>
      );
    } else {
      updateResumeButton = (
        <div className="row">
          {buildFooterLink("/VocationalResume", "Update Resume")}
        </div>
      );
    }
  }

  /*Footer will be shown at Home page. Invisible at PreviewProfile page*/
  if (isShowFooter || isViewAsAdmin) {
    addMoreCanDeliver = (
      <span onClick={toggleClass}>
        <Icon
          name="add"
          circular
          inverted
          color="teal"
          className="qualification-container-update-icon"
        >
          {" "}
        </Icon>
        {"  "}Add New
      </span>
    );
  } else {
    addMoreCanDeliver = null;
  }

  if (isShowFooter || isViewAsAdmin) {
    addMoreRoomsOrPrograms = (
      <span onClick={toggleRoomsOrPrograms}>
        <Icon
          name="add"
          circular
          inverted
          color="teal"
          className="qualification-container-update-icon"
        >
          {" "}
        </Icon>
        {"  "}Add New
      </span>
    );
  } else {
    addMoreRoomsOrPrograms = null;
  }

  if (seeResume) {
    if (user.is_elt) {
      if (user.is_vet) {
        // both elt and vet
        displaySeeResume = (
          <div className="row pb-4">
            <div className="col">
              <Link
                title="ELT Resume"
                to={{
                  pathname: isShared ? "/SharedResume" : "/PreviewResume",
                  data: user,
                }}
              >
                <ConfirmButton>
                  <i className="mdi mdi-briefcase"> </i>
                  See ELT Resume
                </ConfirmButton>
              </Link>
            </div>
            <div className="col">
              <Link
                title="Resume"
                to={{
                  pathname: isShared ? "/SharedVetResume" : "/PreviewVetResume",
                  data: user,
                }}
              >
                <ConfirmButton>
                  <i className="mdi mdi-briefcase"> </i>
                  See VET Resume
                </ConfirmButton>
              </Link>
            </div>
          </div>
        );
      } else {
        // elt only
        displaySeeResume = (
          <div className="pb-4">
            <Link
              title="Resume"
              to={{
                pathname: isShared ? "/SharedResume" : "/PreviewResume",
                data: user,
              }}
            >
              <ConfirmButton>
                <i className="mdi mdi-briefcase"> </i>
                See Resume
              </ConfirmButton>
            </Link>
          </div>
        );
      }
    } else if (user?.is_childhood_teacher) {
      displaySeeResume = (
        <div className="pb-4">
          <div className="col">
            <Link
              title="Resume"
              to={{
                pathname: isShared ? "/SharedEcecResume" : "/PreviewEcecResume",
                data: user,
              }}
            >
              <ConfirmButton>
                <i className="mdi mdi-briefcase"> </i>
                See Resume
              </ConfirmButton>
            </Link>
          </div>
        </div>
      )
    } else {
      // vet only
      displaySeeResume = (
        <div className="pb-4">
          <Link
            title="Resume"
            to={{
              pathname: isShared ? "/SharedVetResume" : "/PreviewVetResume",
              data: user,
            }}
          >
            <ConfirmButton>
              <i className="mdi mdi-briefcase"> </i>
              See Resume
            </ConfirmButton>
          </Link>
        </div>
      );
    }
  } else {
    displaySeeResume = null;
  }

  const buildQualificationContent = (qualifications) => {
    if (user?.is_childhood_teacher) {
      return (
        <ul className="container">
          {qualifications && qualifications.length > 0
            ? qualifications.sort((a, b) => {
              let dateA, dateB;
              dateA =
                a.graduation_date === "Present"
                  ? moment()
                  : moment(a.graduation_date, "MM/YYYY");
              dateB =
                b.graduation_date === "Present"
                  ? moment()
                  : moment(b.graduation_date, "MM/YYYY");
              return dateB.diff(dateA);
            })
            .map((q, index, array) => {
              return (
                <li
                  key={q._id}
                  className="row"
                  hidden={q.degree === "No VET Training Qualification"}
                >
                  <div className="col-8">
                    <p
                      className={
                        "mb-2 profile-box-title" +
                        (q.degree === "No VET Training Qualification"
                          ? " font-weight-normal"
                          : "")
                      }
                    >
                      {q.award_name ? q.award_name : q.degree}
                    </p>
                    <p className="mt-0 mb-2">
                      {q.major ? "(" + q.major + ")" : ""}
                    </p>
                    {q.institution_name ? (
                      <p className="mt-0">
                        {q.institution_name}, {q.institution_location}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-4">
                    <p
                      className="mt-0 mb-0 text-right profile-box-title"
                      hidden={q.degree === "No VET Training Qualification"}
                    >
                      {q.graduation_date !== "Present" ? (
                        // q.graduation_date.length === 7 ? (
                        //   moment(q.graduation_date, "MM/YYYY").format(
                        //     "MMM YYYY"
                        //   )
                        // ) : (
                        //   "NaN"
                        // )
                        moment(q.graduation_date, "MM/YYYY").format("MMM YYYY")
                      ) : (
                        <p className="mt-0 mb-0 profile-qualification-title text-right">
                          Currently Enrolled
                        </p>
                      )}
                    </p>
                  </div>
                  {index !== array.length - 1 && (
                    <div className="col-12">
                      <hr className="qualification-line-1 my-3"></hr>
                    </div>
                  )}
                </li>
              );
            })
            : "No information available"
          }
        </ul>
      );
    }

    if (qualifications && qualifications.length > 0) {
      return (
        <ul className="container">
          {qualifications
            .sort((a, b) => {
              let dateA, dateB;
              dateA =
                a.graduation_date === "Present"
                  ? moment()
                  : moment(a.graduation_date, "MM/YYYY");
              dateB =
                b.graduation_date === "Present"
                  ? moment()
                  : moment(b.graduation_date, "MM/YYYY");
              return dateB.diff(dateA);
            })
            .map((q, index, array) => {
              return (
                <li
                  key={q._id}
                  className="row"
                  hidden={q.degree === "No VET Training Qualification"}
                >
                  <div className="col-8">
                    <p
                      className={
                        "mb-2 profile-box-title" +
                        (q.degree === "No VET Training Qualification"
                          ? " font-weight-normal"
                          : "")
                      }
                    >
                      {q.award_name ? q.award_name : q.degree}
                    </p>
                    <p className="mt-0 mb-2">
                      {q.major ? "(" + q.major + ")" : ""}
                    </p>
                    {q.institution_name ? (
                      <p className="mt-0">
                        {q.institution_name}, {q.institution_location}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-4">
                    <p
                      className="mt-0 mb-0 text-right profile-box-title"
                      hidden={q.degree === "No VET Training Qualification"}
                    >
                      {q.graduation_date !== "Present" ? (
                        // q.graduation_date.length === 7 ? (
                        //   moment(q.graduation_date, "MM/YYYY").format(
                        //     "MMM YYYY"
                        //   )
                        // ) : (
                        //   "NaN"
                        // )
                        moment(q.graduation_date, "MM/YYYY").format("MMM YYYY")
                      ) : (
                        <p className="mt-0 mb-0 profile-qualification-title text-right">
                          Currently Enrolled
                        </p>
                      )}
                    </p>
                  </div>
                  {index !== array.length - 1 && (
                    <div className="col-12">
                      <hr className="qualification-line-1 my-3"></hr>
                    </div>
                  )}
                </li>
              );
            })}
        </ul>
      );
    } else {
      return null;
    }
  };

  const buildProfileQualifications = () => {
    const allQualifications = user.qualifications.concat(
      user.vet_training_quals,
      user.vet_industry_quals
    );

    return buildQualificationContent(allQualifications);
  };

  const modifySelectedList = (userNew) => {
    const { selected_can_delivers, selected_rooms_programs } = userNew
    const selectedItem = {}
    const selectedByQualification = {}
    const roomsOrProgramsEcecList = []
    qualifications.forEach(item => {
        const quaList = item.qualifications
        if(item.type === 'vet') {
            quaList.forEach(qua => {
                const { units } = qua
                units.forEach(unit => {
                    if(selected_can_delivers.includes(unit._id)) {
                        const key = `${qua.title}_keyID:${qua._id}`
                        const unitItem = `${unit.title}_id:${unit._id}`
                        if(selectedItem[key]?.length) {
                            if(!selectedItem[key]?.includes(unitItem)) {
                                selectedItem[key].push(unitItem)
                            }
                        }
                        else {
                            selectedItem[key] = [unitItem]
                        }

                        if(selectedByQualification[qua._id]?.length) {
                          selectedByQualification[qua._id].push(unit._id)
                        }
                        else {
                            selectedByQualification[qua._id] = [unit._id]
                        }
                    }
                })
            })
        }
        else {
            const key = `${item.qualification_name}_keyID:${item._id}`
            quaList.forEach(qua => {
                const quaItem = `${qua.title}_id:${qua._id}`
                if(selected_can_delivers.includes(qua._id)) {
                    if(selectedItem[key]?.length) {
                        if(!selectedItem[key]?.includes(quaItem)) {
                            selectedItem[key].push(quaItem)
                        }
                    }
                    else {
                        selectedItem[key] = [quaItem]
                    }
                }
            })
        }

        if (userNew?.is_childhood_teacher && item.type === "ecec") {
          quaList.forEach((qua => {
            if (selected_rooms_programs.includes(qua._id)) {
              roomsOrProgramsEcecList.push(qua)
            }
          }))
        }
    })
    setSelectedList(selectedItem)
    setSelectedByQualification(selectedByQualification)
    setRoomsOrProgramsList(roomsOrProgramsEcecList)
  }

  const handleSaveCanDeliver = async (selectedCanDelivers) => {
    toggleClassPopup(false);
    if(isViewAsAdmin) {
      const { data } = await API.updateUserInfoByAdmin({ selected_can_delivers: selectedCanDelivers }, user?._id)
      notify.show("Can deliver updated successfully", "custom", 2000, { background: '#FFFFFF', text: "	#000000" });
      setUser(data.user)
      modifySelectedList(data.user)
    } else {
      const { data } = await API.updateUserInfo({selected_can_delivers: selectedCanDelivers})
      notify.show("Can deliver updated successfully", "custom", 2000, { background: '#FFFFFF', text: "	#000000" });
      setUser(data.user)
      modifySelectedList(data.user)
    }
    // window.location.reload()
    // isViewAsAdmin ? addCanDeliverAdmin(newUser) : addCanDeliver(newUser);
    // isViewAsAdmin ?? setUser(newUser);
  };

  const handleSaveRoomOrProgram = async (selectedRoomsPrograms) => {
    setIsRoomsOrProgramsPopup(false);
    if(isViewAsAdmin) {
      const { data } = await API.updateUserInfoByAdmin({ selected_rooms_programs: selectedRoomsPrograms }, user?._id)
      notify.show("Rooms/Programs updated successfully", "custom", 2000, { background: '#FFFFFF', text: "	#000000" });
      setUser(data.user)
      modifySelectedList(data.user)
    } else {
      const { data } = await API.updateUserInfo({selected_rooms_programs: selectedRoomsPrograms})
      notify.show("Rooms/Programs updated successfully", "custom", 2000, { background: '#FFFFFF', text: "	#000000" });
      setUser(data.user)
      modifySelectedList(data.user)
    }
  };

  const fetchFeedback = async (page) => {
    try {
      const response = await API.getFeedbackByTeacherID(user?._id, page);
      setFeedbacks((preState) => ([...preState, ...response.data.data]))
      if(response.data?.paginate?.page < response.data?.paginate?.total_page) {
        setHasMore(true)
      } else {
        setHasMore(false)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFeedbackBadge = async () => {
    try {
      const response = await API.getFeedbackBadgeByTeacherID(user?._id);
      let badges = [];
      const listBadges = Object.keys(response?.data?.data);
      const listCounts = Object.values(response.data.data);
      if (listBadges.length > 0) {
        listBadges.map((item, index) => {
          if (listCounts[index] > 0)
            badges.push({ title: item, count: listCounts[index] });
        });
        setBadges(badges);
      } else {
        const badges = getBadges();
        setBadges(
          badges
            .slice(0, 5)
            ?.map((badge) => ({ title: badge.badge_title, count: 0 }))
        );
      }
      // setBadges(response?.data?.data?.keys())
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchFeedbackBadge()
    modifySelectedList(user)
  }, [])

  return (
    <div className="teacher-profile-wrapper">
      {isClassPopup && <CanDeliverForm
        show={isClassPopup}
        user={user}
        setUser={setUser}
        // addClass={add_class}
        onSubmit={(selectedCanDelivers) => handleSaveCanDeliver(selectedCanDelivers)}
        onClose={() => toggleClassPopup(false)}
        qualifications={qualifications}
        selectedData={_.flatten(Object.values(selectedList))}
        selectedByQualificationObj={selectedByQualification}
        selectedCanDelivers={user.selected_can_delivers}
      />}

      {isRoomsOrProgramsPopup && <RoomOrProgramPopup
        show={isRoomsOrProgramsPopup}
        user={user}
        setUser={setUser}
        // addClass={add_class}
        onSubmit={(selectedCanDelivers) => handleSaveRoomOrProgram(selectedCanDelivers)}
        onClose={() => setIsRoomsOrProgramsPopup(false)}
        qualifications={qualifications}
        selectedData={_.flatten(Object.values(selectedList))}
        selectedByQualificationObj={selectedByQualification}
        selectedRoomsPrograms={user.selected_rooms_programs}
      />}

      <div className="container">
        {/* Qualification Box*/}
        <div className="row">
          <div className="col-md-6">
            <ProfileBox
              header="Qualifications"
              footer={updateResumeButton}
              seeResumeFooter={displaySeeResume}
            >
              {buildProfileQualifications()}
            </ProfileBox>
          </div>

          <div className="col-md-6">
          {
            user?.is_childhood_teacher ? (
              <>
              {/*  Preferred Rooms/Programs Box */}
                <ProfileBox header="Preferred Rooms/Programs" footer={addMoreRoomsOrPrograms}>
                  { roomsOrProgramsList ?
                    <ul className="container p-0">
                      {(
                        <li className="row">
                          {
                            roomsOrProgramsList.map(qualification => {
                              return <div className="col-12">
                                <p className="mb-2 profile-box-title">
                                  {qualification.title}
                                </p>
                              </div>;
                            })
                          }
                        </li>
                      )}
                    </ul>
                    : null
                  }
                </ProfileBox>
              </>
            ) : (
              <>
                {/* Can Deliver Box*/}
                <ProfileBox header="Can Deliver" footer={addMoreCanDeliver}>
                  {/* {user.can_deliver && user.can_deliver.length > 0 ? */}

                  {isCanDeliver && selectedList ?
                    <ul className="container p-0">
                      {(
                        <li className="row">
                          {Object.keys(selectedList)
                            .map((category, index, arr) => {
                              return <div className="col-12">
                                <p className="mb-2 profile-box-title">
                                  {category?.split("_keyID:")?.[0]}
                                </p>
                                <p>
                                  {selectedList[category]
                                    .map((cl) => cl.split("_id:")?.[0])
                                    .join(" | ")}
                                </p>
                                {index !== (arr.length - 1) && <hr className="my-3 qualification-line-1"></hr>}
                              </div>;
                            })}
                        </li>
                      )}
                    </ul>
                    : null
                  }
                </ProfileBox>
              </>
            )
          }
        </div>

        </div>

        {/* Compliment Box. Using HomeCarousel component*/}
        <div className="row">
          <div className="col">
            <ProfileBox header="Compliments">
              {/* compliments go here */}
              {/* {feedbacks && feedbacks?.length > 0 ? (

              ) : null} */}
                <TeacherComplimentsBadge
                  badges={badges}
                  hasMore={hasMore}
                  fetchFeedback={fetchFeedback}
                  comments={feedbacks?.map((feedback) => ({
                    detail: feedback.detail,
                    customer_name: feedback?.customerName,
                    createdAt: moment(feedback.createdAt).format("MMMM	YYYY"),
                  }))}
                />
            </ProfileBox>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherProfile;
